import { cn } from "@/lib/cn";

export function Spinner({ className }: { className?: string }) {
  return (
    <span
      className={cn(
        "inline-block size-5 animate-spin rounded-full border-2 border-brand border-r-transparent",
        className,
      )}
      role="status"
      aria-label="Loading"
    />
  );
}
